import { EXPENSE_STATE_LABELS, ExpensesTable } from "@/components/ExpensesTable";
import { RecordListFilterBar, useRecordListFilters } from "@/components/RecordListFilters";

export function ExpensesPage() {
  const { values, bar } = useRecordListFilters({ states: EXPENSE_STATE_LABELS, textParam: "merchant" });

  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-1 text-2xl font-bold">Expenses</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Card spend across all organisations, most recent spend first.
      </p>

      <RecordListFilterBar filters={bar} textPlaceholder="Filter by merchant..." dateLabel="Spent" />

      <ExpensesTable
        organisationId={values.organisationId}
        filters={{
          states: values.state ? [values.state] : undefined,
          merchant: values.text,
          from: values.from,
          to: values.to,
        }}
      />
    </div>
  );
}
